type AvatarProps = {
  name?: string;
  mark?: string;
  size?: number;
  dark?: boolean;
};

export default function Avatar({ name, mark, size = 32, dark = true }: AvatarProps) {
  const initials =
    mark ||
    (name
      ? name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase()
      : "?");
  return (
    <span
      className="avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
        background: dark ? "var(--night)" : "var(--surface-sunk)",
        color: dark ? "var(--cream-fixed)" : "var(--fg)",
      }}
    >
      {initials}
    </span>
  );
}
